import { AxiosInstance } from "axios";
import _ from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import useNavigate from "src/hooks/usePartnerNavigate";
import { PagePath } from "src/pages/product/details";
import { globalPartnerState, partnersState } from "src/recoil/partners/atom";
import { Partner } from "src/types/partner";
import { axiosInstance, axiosInstanceNoLoading } from "src/utils";

/*
  axios 인스턴스에 파트너 아이디를 주입하는 컴포넌트입니다.
  파트너 아이디가 없는 경우 파트너 선택 페이지로 리디렉션됩니다.
  TODO: async/await 필요 없음
  TODO: useLayoutEffect를 사용하면 될듯
*/
function ParnterInitializer({ children }: { children: React.ReactNode }) {
  const globalPartner = useRecoilValue(globalPartnerState);
  const globalPartners = useRecoilValue(partnersState);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const setGlobalPartner = useSetRecoilState(globalPartnerState);
  const [isDone, setIsDone] = useState(false);

  const setAxiosRequestInterceptor = (axiosInstance: AxiosInstance) => {
    return new Promise((resolve) => {
      const id = axiosInstance.interceptors.request.use((config) => {
        if (config.url?.includes("{partnerId}")) {
          const partnerId = globalPartner?.id || pathPartnerId;
          config.url = config.url.replace("{partnerId}", String(partnerId));
        }
        return config;
      });
      resolve(id);
    });
  };

  const pathPartnerId = useMemo(() => {
    return params.partnerId;
  }, [params.partnerId]);

  useEffect(() => {
    // pathPartnerId 가 있는지 확인
    if (pathPartnerId === undefined) {
      return;
    }

    // partner 정보가 없으면 init 페이지로 이동
    const partner = globalPartners?.find((partner) => String(partner.id) === pathPartnerId);
    if (!partner) {
      if (!!globalPartner) {
        setGlobalPartner(undefined);
      }
      return navigate(PagePath.init);
    }

    // 선택된 파트너가 변경
    if (globalPartner?.id !== partner.id) {
      setGlobalPartner(partner);
    }
  }, [pathPartnerId, globalPartner]);

  useEffect(() => {
    setIsDone(false);
    (async () => {
      const result = await setAxiosRequestInterceptor(axiosInstance);
      const noLoadingResult = await setAxiosRequestInterceptor(axiosInstanceNoLoading);

      setIsDone(true);

      return () => {
        axiosInstance.interceptors.request.eject(result as number);
        axiosInstanceNoLoading.interceptors.request.eject(noLoadingResult as number);
      };
    })();
  }, [globalPartner?.id]);

  if (!isDone) return null;

  return <>{children}</>;
}
export default ParnterInitializer;
